import { ChampionshipsEndpoints } from '../../../endpoint';
import { Models } from '../../..';

interface DeleteChampionship {
  championshipId: Models.ChampionshipId;
}

export const deleteChampionship = async ({ championshipId }: DeleteChampionship) =>
  ChampionshipsEndpoints.deleteChampionship({ championshipId }).then(response => response);
